export default "__VITE_ASSET__BnFzjsPI__"